import type { ComponentSchema } from "../../../../../schema-types";
import { SECTION_STYLE_FIELDS } from "../../_builder-constants";

const ITEM_SCHEMA = [
  { key: "text", label: "Message Text", type: "string" as const },
  { key: "code", label: "Coupon Code (optional)", type: "string" as const },
];

export const schema: ComponentSchema = {
  type: "announcement-bar",
  label: "Announcement Bar",
  description: "A still showroom line: each message after a check mark, spread across the page.",
  supportedPages: [
    "home", "shop", "product", "category", "categories", "cart", "checkout",
    "contact", "wishlist",
  ],
  variants: [
    {
      id: "v1",
      label: "V1 — Showroom line",
      fields: [
        { key: "items", label: "Announcement Items", type: "array", itemSchema: ITEM_SCHEMA },
        { key: "bgColor", label: "Background Color", type: "string", default: "#0989FF" },
        { key: "textColor", label: "Text Color", type: "string", default: "#ffffff" },
      ],
    },
  ],
  commonFields: [...SECTION_STYLE_FIELDS],
};
